import {ILoraForwarderUdpService} from '@/services/lora/forwarder/ILoraForwarderUdp.service';
import {injectable} from 'inversify-props';

import {LoraForwarderGatewayConfiguration} from '@/model/lora/UdpPacketForwarder/LoraForwarderUdpConfig';
import {LoraPacketForwarderStats} from '@/model/lora/LoraPacketForwarderStats';

import {LoraForwarderStdService} from '@/services/lora/forwarder/LoraForwarderStd.service';
import {FrequencyPlan} from '@/model/lora/FrequencyPlan';

@injectable()
export class LoraForwarderUdpService extends LoraForwarderStdService implements ILoraForwarderUdpService {

  constructor() {
    super('/lora/forwarder/udp-packet-forwarder');
  }

  public async getConfig(): Promise<LoraForwarderGatewayConfiguration> {
    const config = await this.apiService.get(`${this.path}/config`);
    return new LoraForwarderGatewayConfiguration(config);
  }

  public async getConfigFileLocal(): Promise<string> {
    return await this.apiService.get(`${this.path}/config-file-local`);
  }

  public async setConfigFileLocal(config: string): Promise<void> {
    return await this.apiService.put(`${this.path}/config-file-local`, config);
  }

  public async getConfigFileGlobal(): Promise<string> {
    return await this.apiService.get(`${this.path}/config-file-global`);
  }

  public async setConfigFileGlobal(config: string): Promise<void> {
    return await this.apiService.put(`${this.path}/config-file-global`, config);
  }

  public async getStats(): Promise<LoraPacketForwarderStats> {
    return this.statsSerializer.parse(await this.apiService.get(`${this.path}/stats`))!;
  }

  public async resetStats(): Promise<void> {
    return await this.apiService.post(`${this.path}/stats/reset`, null);
  }

  public async getFrequencyPlans(): Promise<FrequencyPlan[]> {
    const plansData = await this.apiService.get(`${this.path}/plans`);
    return plansData.map((p: any) => FrequencyPlan.Serializer.parse(p));
  }

  public async getFrequencyPlan(): Promise<FrequencyPlan> {
    return FrequencyPlan.Serializer.parse(await this.apiService.get(`${this.path}/plan`))!;
  }

  public async setFrequencyPlan(id: string, region?: string): Promise<void> {
    return await this.apiService.post(`${this.path}/plan`, {id, region});
  }
}

